import { createAction } from 'typesafe-actions'
import { toast, ToastOptions } from 'react-toastify'

export const notify = createAction('NOTIFY', (payload: string, meta?: Partial<ToastOptions>) => {
  toast(payload, meta)
  return {
    payload,
    meta,
  }
})
